import format from "date-fns/format";
import React, { useEffect } from "react";
import { HiOutlineDocumentText } from "react-icons/hi";
import { TbTicket } from "react-icons/tb";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import useMethodAccount from "../hooks/useMethodAccount";
import "./style.scss";
import getId from "../../../../utils/getId";
import { BiCommentError } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import EAButton from "../../shared/Buttons/EAButton";

const AccountDocuments: React.FC = () => {
  const logoUrl = useSelector((state: State) => state.config.facilityLogoUrl);
  const { t } = useTranslation();

  const { getUserDocuments, docs, getBoughtTickets, getDownloadDocument } = useMethodAccount();

  useEffect(() => {
    getUserDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="account-documents">
        <h3 className="ticket-title flex-start-center">
          {" "}
          <HiOutlineDocumentText className="icon" />
          {t("twoje_dokumenty")}
        </h3>

        <div className="flex-start-center flex-wrap">
          {docs.length > 0 ? (
            <>
              {docs.map((item, index) => (
                <div className={"account-documents-single border shadow flex-between-center"} key={index}>
                  <img className="logo-document" src={logoUrl} alt="Logo dokumenty" />

                  <div className="flex-column account-column ">
                    {item.paymentStatus === "R" && <b>{t("zwrocony")}</b>}

                    <b>{item.documentNumber}</b>
                    <span>{t("numer_zamowienia")}</span>
                  </div>

                  <div className="flex-column account-column">
                    <b>{format(item.paymentDate, "dd.MM.yyyy")}</b>
                    <span>{t("data_zamowienia")}</span>

                    <strong>
                      {t("kwota")}: {item.total} {t("zl")}
                    </strong>
                  </div>

                  <div className="buttons flex-column">
               
                    <EAButton
                      title={t("pobierz_dokument")}
                      onClick={() => getDownloadDocument(getId(item))}
                      startIcon={<HiOutlineDocumentText />}
                      variant="outlined"
                    />
                         {item.hasTickets && (
                      <EAButton
                        title={t("pobierz_bilety")}
                        onClick={() => getBoughtTickets(getId(item))}
                        startIcon={<TbTicket />}
                      />
                    )}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <>
              <div className="alert alert-yellow">
                <BiCommentError className="alert-icon" />
                <b>{t("brak_dokumentow")}</b>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default AccountDocuments;
